import { Link } from 'react-router-dom';
import { DiscordIcon } from './Icons';

export function Footer() {
  const invite = import.meta.env.VITE_DISCORD_INVITE_URL || 'https://discord.gg/hAqvebcSh3';
  const hostname = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
  const isSubdomain = hostname.startsWith('apply.') || hostname.startsWith('rules.');
  const mainHost = 'https://ugeappagesmp.online';

  return (
    <footer className="footer-grand">
      <div className="footer-aurora" aria-hidden="true">
        <span className="aurora-beam beam-1" />
        <span className="aurora-beam beam-2" />
      </div>

      <div className="footer-shell">
        <div className="footer-content-clean">
          {/* Brand Info */}
          <div className="footer-brand-side">
            {isSubdomain ? (
              <a href={`${mainHost}/`} className="footer-brand-header">
                <img
                  src="/assets/ugeappage-logo-zoomed.webp"
                  alt="Uge Appage SMP"
                  className="footer-brand-logo"
                />
                <div>
                  <b>UGE APPAGE SMP</b>
                  <small>SEASON III · SRI LANKA</small>
                </div>
              </a>
            ) : (
              <Link to="/" className="footer-brand-header">
                <img
                  src="/assets/ugeappage-logo-zoomed.webp"
                  alt="Uge Appage SMP"
                  className="footer-brand-logo"
                />
                <div>
                  <b>UGE APPAGE SMP</b>
                  <small>SEASON III · SRI LANKA</small>
                </div>
              </Link>
            )}
            <p className="footer-brand-text">
              A sovereign player-built Minecraft civilization. Trade, build, and write history.
            </p>
            <div className="footer-social-row">
              <a href={invite} target="_blank" rel="noreferrer" className="social-pill discord">
                <DiscordIcon size={14} /> <span>Discord</span>
              </a>
              <a href="https://www.youtube.com/@UgeAppageSMP" target="_blank" rel="noreferrer" className="social-pill youtube">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span>YouTube</span>
              </a>
            </div>
          </div>

          {/* Clean Navigation Links */}
          <div className="footer-nav-clean">
            <div className="footer-links-group">
              <span className="footer-group-title">EXPLORE</span>
              <ul className="footer-group-list">
                <li>{isSubdomain ? <a href={`${mainHost}/`}>Home</a> : <Link to="/">Home</Link>}</li>
                <li>{isSubdomain ? <a href={`${mainHost}/about`}>About Us</a> : <Link to="/about">About Us</Link>}</li>
                <li>{isSubdomain ? <a href={`${mainHost}/journey`}>Our Journey</a> : <Link to="/journey">Our Journey</Link>}</li>
                <li>{isSubdomain ? <a href={`${mainHost}/events`}>Events Roadmap</a> : <Link to="/events">Events Roadmap</Link>}</li>
                <li><a href={`${mainHost}/#episodes`}>Episodes</a></li>
                <li><a href="https://rules.ugeappagesmp.online/">Rules</a></li>
              </ul>
            </div>

            <div className="footer-links-group">
              <span className="footer-group-title">COMMUNITY</span>
              <ul className="footer-group-list">
                <li>{isSubdomain ? <a href={`${mainHost}/economy`}>Economy</a> : <Link to="/economy">Economy</Link>}</li>
                <li>{isSubdomain ? <a href={`${mainHost}/profile`}>My Dossier</a> : <Link to="/profile">My Dossier</Link>}</li>
                <li><a href={`${mainHost}/#legends`}>Hall of Legends</a></li>
                <li><a href="https://apply.ugeappagesmp.online/">Apply for Whitelist</a></li>
                <li><a href={invite} target="_blank" rel="noreferrer">Join Discord</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Clean Minimalist Bottom Line */}
        <div className="footer-bottom-clean">
          <span>© {new Date().getFullYear()} <b>Uge Appage SMP</b>. All rights reserved.</span>
          <span className="footer-note">Not affiliated with Mojang Studios.</span>
        </div>
      </div>
    </footer>
  );
}
